import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import { Box, Grid } from "@material-ui/core";
import TextFieldRtl from "../../UI/TextFieldRtl/TextFieldRtl";
import ChequeAddFormChequeableCar from "./ChequeAddFormChequeableCar";
import ChequeAddFormChequeableCheque from "./ChequeAddFormChequeableCheque";

const StyledTextField = TextFieldRtl();

const ChequeAddFromChequeable = (props) => {
  const { values, setFieldValue } = props;

  React.useEffect(() => {}, []);

  return (
    <Wrapper>
      <Grid item xs={12} md={6} p={1}>
        <Box p={1}>
          <StyledTextField
            name={"chequeable_type"}
            id={"chequeable_type"}
            fullWidth={true}
            label={"نوع چک"}
            variant="outlined"
            SelectProps={{
              native: true,
            }}
            onChange={(e) => {
              setFieldValue("chequeable_id", "");
              setFieldValue("chequeable_name", "");
              setFieldValue("chequeable_type", e.target.value);
            }}
            select
          >
            <option value={null}>انتخاب کنید</option>
            <option
              selected={values.chequeable_type === "car_contract"}
              value={"car_contract"}
            >
              معاملات ماشین
            </option>
            <option
              selected={values.chequeable_type === "cheque_contract_recieved"}
              value={"cheque_contract_recieved"}
            >
              خرید دین - چک ورودی
            </option>
            <option
              selected={values.chequeable_type === "cheque_contract_given"}
              value={"cheque_contract_given"}
            >
              خرید دین - چک خروجی
            </option>
            <option
              selected={values.chequeable_type === "other"}
              value={"other"}
            >
              سایر
            </option>
          </StyledTextField>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        {values.chequeable_type === "car_contract" ? (
          <Wrapper>
            <ChequeAddFormChequeableCar
              value={values.chequeable_name}
              {...props}
            />
          </Wrapper>
        ) : values.chequeable_type === "cheque_contract_recieved" ||
          values.chequeable_type === "cheque_contract_given" ? (
          <Wrapper>
            <ChequeAddFormChequeableCheque
              typeCheck={values.chequeable_type}
              {...props}
              value={values.chequeable_name}
            />
          </Wrapper>
        ) : (
          <Box p={1}>
            <TextFieldHelper
              title={"بابت"}
              fieldName={"chequeable_id"}
              {...props}
            />
          </Box>
        )}
      </Grid>
    </Wrapper>
  );
};

export default ChequeAddFromChequeable;
